import { render, staticRenderFns } from "./AscAlertIconLabel.vue?vue&type=template&id=1df0e59a&"
import script from "./AscAlertIconLabel.vue?vue&type=script&lang=js&"
export * from "./AscAlertIconLabel.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertIconLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports